import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

import CN from './StoppedSms.module.scss';

const StoppedSms = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="StoppedSms" className={CN.container}>
      <h5>
        <span className={CN.emoji} role="img" aria-labelledby="Warning">
          ⚠️
        </span>
        {t('composite.clientProfile.stoppedSms.title')}
        <span className={CN.emoji} role="img" aria-labelledby="Warning">
          ⚠️
        </span>
      </h5>
      <div className={CN.text}>{t('composite.clientProfile.stoppedSms.description')}</div>
    </div>
  );
};

export default StoppedSms;
